import { Control } from "rete";
import NumberComponent from "./number-component";

export class NumberControl extends Control {
  constructor(
    emitter,
    key,
    type,
    readonly,
    placeholder,
    secondary,
    defaultValue
  ) {
    super(key);
    this.component = NumberComponent;
    this.props = {
      emitter,
      ikey: key,
      type,
      readonly,
      placeholder,
      secondary,
      defaultValue
    };
  }

  setValue(value) {
    this.vueContext.value = value;
  }
}
